import MarxyApiService from './api'

/**
 * @param fn
 * @returns {Promise<void>}
 */
export async function safeMarxyCall(fn: Function) {
  try {
    await fn()
  } catch (e) {
    await MarxyApiService.apiLog(`Marxy safeTrackEventCall [${e.message}]`, e)
  }
}

export async function marxyDeprecatedApi(name: string) {
  await MarxyApiService.apiLog(
    `Marxy deprecated: Was used [${name}]`,
    new Error()
  )
}
